import { render, staticRenderFns } from "./LoyaltyTerminalesPuntosColombia.vue?vue&type=template&id=1097d5f4"
import script from "./LoyaltyTerminalesPuntosColombia.vue?vue&type=script&lang=js"
export * from "./LoyaltyTerminalesPuntosColombia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/mahalo_integrador/hiopos/reports-co/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1097d5f4')) {
      api.createRecord('1097d5f4', component.options)
    } else {
      api.reload('1097d5f4', component.options)
    }
    module.hot.accept("./LoyaltyTerminalesPuntosColombia.vue?vue&type=template&id=1097d5f4", function () {
      api.rerender('1097d5f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/administration/components/LoyaltyConfig/LoyaltyTerminalesPuntosColombia.vue"
export default component.exports